//noScroll
class MegaMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // サービスを知る
    const megaMenu = document.querySelector(".js-megaMenu");
    const megaTrigger = document.querySelector(".js-megaTrigger");
    // 店舗に電話、LINE追加
    const megaTriggerClick = document.querySelectorAll(".js-megaTrigger-click");
    const megaMenuClick = document.querySelectorAll(".js-megaMenu-click");
    const overlay = document.querySelector(".overlay");
    const header = document.querySelector(".l-header");
    // メガメニュー以外のリンクを取得
    const headerLink = document.querySelectorAll(".header-link");

    // サービスを知る
    function handleMouseover() {
      megaMenu.classList.add('is-open');
      megaTrigger.classList.add('is-active');
      overlay.classList.add('is-active');
      header.classList.add('shadow-hidden');
      megaMenuClick.forEach(element => {
        element.classList.remove('is-open');
      });
    }
    function handleMouseleave() {
      megaMenu.classList.remove('is-open');
      megaTrigger.classList.remove('is-active');
      overlay.classList.remove('is-active');
      header.classList.remove('shadow-hidden');
    }
    megaTrigger.addEventListener('mouseover', handleMouseover);
    megaMenu.addEventListener('mouseover', handleMouseover);
    megaTrigger.addEventListener('mouseleave', handleMouseleave);
    megaMenu.addEventListener('mouseleave', handleMouseleave);

    // 店舗案内
    function handleMouseover_shop() {
      megaMenu_shop.classList.add('is-open');
      megaTrigger_shop.classList.add('is-active');
      overlay.classList.add('is-active');
      header.classList.add('shadow-hidden');
      megaMenuClick.forEach(element => {
        console.log(element);
        element.classList.remove('is-open');
      });
    }
    function handleMouseleave_shop() {
      megaMenu_shop.classList.remove('is-open');
      megaTrigger_shop.classList.remove('is-active');
      overlay.classList.remove('is-active');
      header.classList.remove('shadow-hidden');
    }
    // サービスを知る
    const megaMenu_shop = document.querySelector(".js-megaMenu_shop");
    const megaTrigger_shop = document.querySelector(".js-megaTrigger_shop");
    megaTrigger_shop.addEventListener('mouseover', handleMouseover_shop);
    megaMenu_shop.addEventListener('mouseover', handleMouseover_shop);
    megaTrigger_shop.addEventListener('mouseleave', handleMouseleave_shop);
    megaMenu_shop.addEventListener('mouseleave', handleMouseleave_shop);

    // // 店舗案内
    // function handleMouseover_access() {
    //   megaMenu_access.classList.add('is-open');
    //   megaTrigger_access.classList.add('is-active');
    //   overlay.classList.add('is-active');
    //   header.classList.add('shadow-hidden');
    //   megaMenuClick.forEach(element => {
    //     console.log(element);
    //     element.classList.remove('is-open');
    //   });
    // }
    // function handleMouseleave_access() {
    //   megaMenu_access.classList.remove('is-open');
    //   megaTrigger_access.classList.remove('is-active');
    //   overlay.classList.remove('is-active');
    //   header.classList.remove('shadow-hidden');
    // }

    // // 店舗案内
    // const megaMenu_access = document.querySelector(".js-megaMenu_access");
    // const megaTrigger_access = document.querySelector(".js-megaTrigger_access");
    // megaTrigger_access.addEventListener('mouseover', handleMouseover_access);
    // megaMenu_access.addEventListener('mouseover', handleMouseover_access);
    // megaTrigger_access.addEventListener('mouseleave', handleMouseleave_access);
    // megaMenu_access.addEventListener('mouseleave', handleMouseleave_access);

    
    megaTriggerClick.forEach(triggerItem => {
      triggerItem.addEventListener('mouseover', () => {

        // 他のtriggerItemからis-activeを除去
        megaTriggerClick.forEach(item => {
          if (item !== triggerItem) {
            item.classList.remove('is-active');
          }
        });
        megaMenuClick.forEach(menu => {
          if (menu !== triggerItem) {
            menu.classList.remove('is-active');
          }
        });

        // トリガーのdata属性を取得
        const triggerNum = triggerItem.getAttribute("data-num");

        megaMenuClick.forEach(menu => {
          // メニューのdata属性を取得
          const menuNum = menu.getAttribute("data-index");

          if (triggerNum === menuNum) {
            menu.classList.add('is-open');
            triggerItem.classList.add("is-active");
            overlay.classList.add("is-active");
            header.classList.add("shadow-hidden");

            triggerItem.addEventListener('mouseover', () => {
              triggerItem.classList.add("is-active");
            });

            menu.addEventListener('mouseover', () => {
              menu.classList.add('is-open');
              overlay.classList.add("is-active");
            });

            menu.addEventListener('mouseout', () => {
              menu.classList.remove('is-open');
              overlay.classList.remove("is-active");
            });
            
            [menu, triggerItem, overlay].forEach(ele => {
              ele.addEventListener('click', () => {
                menu.classList.remove('is-open');
                triggerItem.classList.remove("is-active");
                overlay.classList.remove("is-active");
                header.classList.remove("shadow-hidden");
              });
            });
          } else {
            menu.classList.remove("is-open");
          }
        });

        headerLink.forEach(headerLinkItem => {
          
          headerLinkItem.addEventListener('mouseover', () => {
            megaMenuClick.forEach(menu => {
              menu.classList.remove('is-open');
            });
          
            megaTriggerClick.forEach(triggerItem => {
              triggerItem.classList.remove("is-active");
            });
          
            overlay.classList.remove("is-active");
            header.classList.remove("shadow-hidden");
          });
        });

      });
    });

    // スクロール時にクラスを外す記述
    // window.addEventListener('scroll', () => {
    //   if (megaMenu.classList.contains('is-open') || megaTrigger.classList.contains('is-active') || overlay.classList.contains('is-active')) {
    //     megaMenu.classList.remove('is-open');
    //     megaTrigger.classList.remove('is-active');
    //     overlay.classList.remove('is-active');
    //     header.classList.remove('shadow-hidden');
    //   }
    //   megaTriggerClick.forEach(triggerItem => {
    //     triggerItem.classList.remove("is-active");
    //   });

    //   megaMenuClick.forEach(menu => {
    //     menu.classList.remove('is-open');
    //   });
    // });
  }
}
